<template>
  <div>
    <v-container fluid class="login-container" :key="$route.fullPath">
      <v-row justify="center" align="center" class="min-height-screen">
        <v-col cols="12" sm="10" md="8" lg="6" xl="5">
          <div class="main-wrapper">
            <v-card class="login-card elevation-8 mb-4">
              <div class="card-header">
                <div class="header-icon">
                  <v-icon size="32" color="white">mdi-lock-check</v-icon>
                </div>
                <h2 class="header-title">Alterar Senha</h2>
              </div>
              <v-card-text class="pa-6">
                <v-text-field
                  v-model="inputChave"
                  required
                  outlined
                  class="custom-input"
                  prepend-inner-icon="mdi-key"
                  maxlength="100"
                  placeholder="Informe a chave recebida por e-mail"
                  autocomplete="off"
                  :name="'codigoRecuperacao_' + Date.now()"
                />
                <v-text-field
                  v-model="inputNovaSenha"
                  required
                  outlined
                  class="custom-input"
                  prepend-inner-icon="mdi-lock"
                  type="password"
                  maxlength="50"
                  placeholder="Digite a nova senha"
                  autocomplete="new-password"
                  :name="'novaSenha_' + Date.now()"
                />
                <v-text-field
                  v-model="inputConfirmaSenha"
                  required
                  outlined
                  class="custom-input"
                  prepend-inner-icon="mdi-lock"
                  type="password"
                  maxlength="50"
                  placeholder="Confirme a nova senha"
                />
                <v-alert v-if="getMsnSetSenha" type="info" class="mb-4" dense>
                  {{ getMsnSetSenha }}
                </v-alert>
                <v-btn @click="alterarSenha" color="primary" class="validate-btn elevation-4 mt-4" block large>
                  <v-icon left>mdi-lock-reset</v-icon>
                  Alterar Senha
                </v-btn>
                <v-alert v-if="msg" :type="msgType" class="mt-4" dense>
                  {{ msg }}
                </v-alert>
              </v-card-text>
            </v-card>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <v-dialog v-model="loading" persistent max-width="300">
      <v-card color="primary" dark>
        <v-card-text class="d-flex flex-column align-center">
          <v-progress-circular indeterminate color="white" size="40" class="mb-4" />
          <span>Aguarde...</span>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import CredenciamentoServices from "@/services/acesso/CredenciamentoServices";
export default {
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.inputChave = "";
      vm.inputNovaSenha = "";
      vm.inputConfirmaSenha = "";
      vm.msg = "";
      vm.msgType = "info";
    });
  },
  beforeRouteUpdate(to, from, next) {
    this.inputChave = "";
    this.inputNovaSenha = "";
    this.inputConfirmaSenha = "";
    this.msg = "";
    this.msgType = "info";
    next();
  },
  name: "AlterarSenha",
  data: () => ({
    inputChave: "",
    inputNovaSenha: "",
    inputConfirmaSenha: "",
    msg: "",
    msgType: "info",
    loading: false,
  }),
  computed: {
    ...mapGetters({ getMsnSetSenha: "login/getMsnSetSenha" }),
  },
  mounted() {
    if (localStorage.getItem("token")) {
      this.$router.push({ name: "homeMain" }); // HomeAvaliacao.vue agora é o componente da rota 'homeAvaliacao'
      return;
    }
    this.limparInputs();
    this.msg = "";
    this.msgType = "info";
  },
  methods: {
    limparInputs() {
      this.inputChave = "";
      this.inputNovaSenha = "";
      this.inputConfirmaSenha = "";
    },
    async alterarSenha() {
      if (!this.inputChave || !this.inputNovaSenha || !this.inputConfirmaSenha) {
        this.$toast.error("Preencha todos os campos.");
        return;
      }
      if (this.inputNovaSenha !== this.inputConfirmaSenha) {
        this.$toast.error("As senhas não conferem.");
        return;
      }
      if (this.inputNovaSenha.length < 6) {
        this.$toast.error("A senha deve ter pelo menos 6 caracteres.");
        return;
      }
      this.loading = true;
      try {
        const payload = {
          key: this.inputChave,
          senha: this.inputNovaSenha,
          confirmarSenha: this.inputConfirmaSenha,
        };
        const response = await CredenciamentoServices.trocarSenha(payload);
        if (response.success) {
          this.$toast.success(response.message || "Senha alterada com sucesso!");
          setTimeout(() => {
            this.$router.push({ name: "Login" });
          }, 1800);
        } else {
          this.$toast.error(response.message || "Não foi possível alterar a senha.");
        }
      } catch (e) {
        this.$toast.error("Erro ao tentar alterar senha. Tente novamente mais tarde.");
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.login-container {
  background: linear-gradient(135deg, #efebe9 0%, #bcaaa4 100%);
  min-height: 100vh;
  padding: 24px 16px;
}
.min-height-screen {
  min-height: calc(100vh - 48px);
}
.main-wrapper {
  animation: fadeInUp 0.8s ease-out;
}
.login-card {
  border-radius: 16px !important;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  overflow: hidden;
  animation: slideInUp 0.6s ease-out 0.2s both;
}
.card-header {
  background: linear-gradient(135deg, #ffccbc 0%, #d84315 100%);
  padding: 24px;
  text-align: center;
  position: relative;
}
.header-icon {
  position: relative;
  z-index: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  margin-bottom: 16px;
}
.header-title {
  position: relative;
  z-index: 1;
  color: white;
  font-weight: 300;
  margin: 0;
}
.custom-input {
  margin-bottom: 16px;
}
.validate-btn {
  border-radius: 8px !important;
  height: 48px !important;
  font-weight: 600;
  text-transform: none;
  letter-spacing: 0.5px;
}
</style>
